/**
 * useHasMounted — returns `true` only after the first client-side render.
 *
 * Use this to gate UI that depends on browser-only state (online status,
 * SSE health, localStorage, navigator.share, etc.) so SSR renders nothing
 * and only the client renders the conditional output. Without the gate,
 * SSR may emit one DOM shape while client hydration emits another, leaving
 * the user with two stacked components when React falls back to a full
 * client re-render after a hydration mismatch.
 */
import { useEffect, useState } from "react";

export function useHasMounted(): boolean {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);
  return mounted;
}
